import React from "react";
import * as Icons from "react-feather";
import { Link } from "react-router-dom";

export default function Logo() {
  return (
    <>
      <Link to="/dashboard" className="-intro-x hidden md:flex">
        <img alt="vod" className="h-10" src="/images/LogoAr.svg" />
      </Link>
    </>
  );
}
